// Shared constants — kept as strings so the Worker can inject them into
// Langfuse prompt templates via {{severity_prompt}} etc.

export const C = {
  bg: '#c8d8df',
  surface: '#f5f0ea',
  surfaceAlt: '#e8ddd0',
  border: '#c4b8aa',
  borderLight: '#d9d0c4',
  navy: '#1a2e4a',
  navyLight: '#2d4263',
  navyMuted: '#5a6e82',
  gold: '#e8b84b',
  goldDark: '#c99a2e',
  goldBg: '#fdf4dc',
  teal: '#2a9d8f',
  tealBg: '#dff0ed',
  text: '#1a2e4a',
  textMuted: '#6b7a8d',
  textLight: '#8a9aab',
  regulatory: '#c0392b',
  regulatoryBg: '#f9e0dd',
  enablement: '#4a5da8',
  enablementBg: '#e0e4f0',
  bau: '#9b59b6',
  bauBg: '#f0e4f6',
  green: '#d4edda',
  pink: '#f5d0ce',
};

export const serif = "'Libre Baskerville', 'Georgia', serif";
export const sans = "'DM Sans', 'Helvetica Neue', sans-serif";
export const mono = "'DM Mono', 'Courier New', monospace";

export const URGENCY_DRIVERS = [
  'Regulatory deadline',
  'Contractual commitment',
  'Dependency chain',
  'Seasonal window',
  'Growth opportunity',
  'Operational pressure',
  'Strategic horizon',
];

export type SeverityKey = 'P1' | 'P2' | 'P3';

export const SEVERITY_DEFINITIONS: Record<SeverityKey, { label: string; description: string; short: string }> = {
  P1: {
    label: 'P1',
    description: "Prevents customers from completing orders, poses a regulatory or data risk, takes a primary revenue channel completely offline, or prevents a significant portion of the team from performing their core function with no workaround.",
    short: 'Critical impact, no workaround',
  },
  P2: {
    label: 'P2',
    description: "Materially impairs the business's ability to serve its primary objectives, or meaningfully degrades a key user journey or operational process. Impact is ongoing and significant even if a workaround exists.",
    short: 'Significant impact, workaround may exist',
  },
  P3: {
    label: 'P3',
    description: 'Low or uncertain impact. Cosmetic, localised, speculative, or too undefined to assess.',
    short: 'Low or uncertain impact',
  },
};

export const SEVERITY_PROMPT = `SEVERITY DEFINITIONS (use these exactly):
- P1: Prevents customers from completing orders, poses a regulatory or data risk, takes a primary revenue channel completely offline, or prevents a significant portion of the team from performing their core function with no workaround.
- P2: Materially impairs the business's ability to serve its primary objectives, or meaningfully degrades a key user journey or operational process. Impact is ongoing and significant even if a workaround exists.
- P3: Low or uncertain impact. Cosmetic, localised, speculative, or too undefined to assess.`;

export const inputStyle: React.CSSProperties = {
  width: '100%',
  padding: '10px 12px',
  borderRadius: 4,
  border: `1px solid ${C.border}`,
  background: C.surfaceAlt,
  fontFamily: sans,
  fontSize: 13,
  color: C.navy,
  lineHeight: 1.5,
  boxSizing: 'border-box',
  outline: 'none',
};

export const TYPE_EMOJI: Record<'Bug' | 'Feature' | 'Chore', string> = {
  Bug: '🐛',
  Feature: '✨',
  Chore: '🔧',
};
